import { render, staticRenderFns } from "./UsuarioAMView.vue?vue&type=template&id=327356e0&scoped=true&"
import script from "./UsuarioAMView.vue?vue&type=script&lang=ts&"
export * from "./UsuarioAMView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327356e0",
  null
  
)

export default component.exports